import { OneSchemaImporterClass } from '@oneschema/importer'
import { defineNuxtPlugin } from 'nuxt/app'
import { oneschemaConfig } from '@/api/oneschema/config'

export default defineNuxtPlugin((app) => {
  const importer = new OneSchemaImporterClass(oneschemaConfig)

  app.provide('osImporter', importer)
})
